import { useEffect } from 'react';
import { Footer } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Languages } from '~/constants/enums';
import { useAppSelector } from '~/redux/hooks';
import Navbar from '~/components/Navbar';
import SaudiTopBanner from '~/components/SaudiTopBanner';
import TermsAndConditionsModal from '~/components/TermsAndConditionsModal';

const RootLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation('app');
  const { footerDisplay } = useAppSelector((state) => state.uiState);

  useEffect(() => {
    const [language] = location.pathname.slice(1).split('/');
    i18n.changeLanguage(language);
  }, [i18n, location.pathname]);

  useEffect(() => {
    const [language, ...path] = location.pathname.slice(1).split('/');
    const languages = [Languages.ENGLISH, Languages.ARABIC];
    const isLangExist = Boolean(languages.find((lang) => lang === language));

    if (!isLangExist) {
      navigate(
        {
          ...location,
          pathname: `/${[Languages.ARABIC, ...path].join('/')}`,
        },
        { replace: true },
      );
    }
  }, [i18n.language, location, navigate]);

  useEffect(() => {
    if (i18n.language !== 'en') document.body.setAttribute('dir', 'rtl');
    else document.body.setAttribute('dir', 'ltr');
  }, [i18n.language]);

  return (
    <div className="flex flex-col w-full min-h-[100vh] relative">
      <SaudiTopBanner />
      <Navbar />
      <main className="flex-1 flex root-layout-container">
        <Outlet />
      </main>
      <TermsAndConditionsModal />
      {footerDisplay === 'show' && (
        <Footer
          locale={i18n.language}
          supportEmail="support@aqarmap.com"
          translations={{
            description: t('footerDescription'),
            terms: t('terms'),
            map: t('footerMap'),
            contactBy: t('footerContactBy'),
            email: t('email'),
            downloadApp: t('downloadApp'),
            jobs: t('jobs'),
            importantLinks: t('footerImportantLinks'),
            research: t('footerResearch'),
            whatsapp: t('whatsapp'),
          }}
        />
      )}
    </div>
  );
};

export default RootLayout;
